export default __webpack_public_path__ + "static/media/home-photography-img-08.9b777ba8.jpg";